var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"app"},[_c('div',{staticClass:"hero_img"},[_c('img',{staticClass:"ue_1",attrs:{"src":require("@/assets/udeevent/ue_1.png")}}),_c('p',{staticClass:"ue2_t1"},[_vm._v("本公司2022年度桌曆贈獎活動已結束，感謝您的支持! 恭祝新的一年事事順心、萬事如意!")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }